export abstract class ApplicationRoutes {
    // App Root
    static applicationRoot = '/';

    // Auth And Registration ================
    static callback = '/callback';
    static logout = '/logout';
    static register = '/register';

    // Public Enrollment
    static publicEnrollmentLanding = '/enroll';
}